module.exports = __webpack_public_path__ + "static/img/visitor-common.da5e706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/visitor-common.png
// module id = G9ZM
// module chunks = 9